import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import {Tab, Tabs, TabList, TabPanel}   from 'react-tabs';
import SegmentUtils                     from '../../utils/segment-utils';
import JsonControl                      from './JsonControl.js';
import GoogleMap                        from './GoogleMap.js';
import MetaCartaMap                     from './MetaCartaMap';
import DataControl                      from './DataControl';
import TagFeedbackControl               from './TagFeedbackControl';

class SidebarControl extends Component {
    constructor(props){
        super(props);

        this.state = {
            activeDemo: this.props.activeDemo
        }

        this.mapDisable = window._mapDisable;
        this.mapMetaCartaUrl = window._mapMetaCartaUrl;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.activeDemo != this.props.activeDemo) {
            this.setState({
                activeDemo: nextProps.activeDemo
            })
        }
    }

    render() {     
        
        var places = false; 
		var bigMapSize = {width: 100 + '%', height: 350 + 'px'};
        
        if (this.props.results.entities && this.props.results.entities.entities) {
            for(var i =0; i < this.props.results.entities.entities.length; i++){
                if (this.props.results.entities.entities[i].entities[0] && ('type' in this.props.results.entities.entities[i].entities[0])) {
                    if (this.props.results.entities.entities[i].entities[0].type ==='GEO' || 
                        this.props.results.entities.entities[i].entities[0].type ==='URI' || this.props.results.entities.entities[i].entities[0].type ==='IPV4' ||
                        this.props.results.entities.entities[i].entities[0].type.startsWith('ORGANIZATION') ||
                        this.props.results.entities.entities[i].entities[0].type.startsWith('THING')) 
                    {
                        places = true; 
                        break;
                    }
                }
            }
        }
        return (
            <Tabs className="sidebarcontrol-wrapper">
                <TabList>
                    {(this.state.activeDemo === 'entities') &&
                    <Tab>Data</Tab>
                    }
                    {(this.state.activeDemo === 'tag') &&
                    <Tab>Document Tags</Tab>
                    }
                    <Tab>Json</Tab>
                    {(this.state.activeDemo === 'entities' && !this.mapDisable) &&
                    <Tab>Map</Tab>
                    }
                </TabList>

                {(this.state.activeDemo === 'entities') &&
                <TabPanel>
                    <DataControl entities={this.props.results.entities && this.props.results.entities.entities || []} 
                        entitiesData={this.props.results.entitiesData || []} 
                        json = {this.props.results.entities && this.props.results.entities.json || {}}
                        minConfidence={SegmentUtils.minConfidence(this.props.results.entities && this.props.results.entities.entities || [])} 
                        keyPhrases={this.props.results.entities && this.props.results.entities.keyPhrases || []}
                        keyPhraseWeights={this.props.results.entities && this.props.results.entities.keyPhraseWeights || []}
                        topicVector={this.props.results.entities && this.props.results.entities.topicVector || {}}
                        industries={this.props.results.entities && this.props.results.entities.industries || null}
                        relationships={this.props.results.entities && this.props.results.entities.relationships || null}
                        salience={this.props.results.entities && this.props.results.entities.salience || null}
                    />
                </TabPanel>
                }
                {(this.state.activeDemo === 'tag') &&
                <TabPanel>
                    <TagFeedbackControl text={this.props.text} tags={this.props.results.tag && this.props.results.tag.tags || null}/>
                </TabPanel>
                }
                {(this.state.activeDemo === 'entities') &&
                <TabPanel>
                    <JsonControl results={this.props.results.entities && this.props.results.entities.json || null} showCopyToClipboard={true}/>
                </TabPanel>
                }
                {(this.state.activeDemo === 'sentiment') &&
                <TabPanel>
                    <JsonControl results={this.props.results.sentiment&& this.props.results.sentiment.json || null} showCopyToClipboard={true}/>
                </TabPanel>
                }
                {(this.state.activeDemo === 'summary') &&
                <TabPanel>
                    <JsonControl results={this.props.results.summary && this.props.results.summary.json || null} showCopyToClipboard={true}/>
                </TabPanel>
                }
                {(this.state.activeDemo === 'tag') &&
                <TabPanel>
                    <JsonControl results={this.props.results.tag && this.props.results.tag.json || []} showCopyToClipboard={true}/>
                </TabPanel>
                }
                {(this.state.activeDemo === 'translate') &&
                <TabPanel>
                    <JsonControl results={this.props.results.translate && this.props.results.translate.json || []} showCopyToClipboard={true}/>
                </TabPanel>
                }
                {(this.state.activeDemo === 'headline') &&
                <TabPanel>
                    <JsonControl results={this.props.results.headline && this.props.results.headline.json || []} showCopyToClipboard={true}/>
                </TabPanel>
                }
                {(this.state.activeDemo === 'entities' && !this.mapDisable) &&
                <TabPanel>
                    {this.mapMetaCartaUrl ? 
                        <MetaCartaMap className="map-container" 
                            hidden={places===false} 
                            results={this.props.results.entities && this.props.results.entities.entities || null}/>
                        :
                        <GoogleMap className="map-container" 
                            style={bigMapSize} 
                            hidden={places===false} 
                            results={this.props.results.entities && this.props.results.entities.entities || null}/>
                    }
                </TabPanel>
                }
            </Tabs>
        );
    }
}

SidebarControl.propTypes = {
    activeDemo: PropTypes.string.isRequired,
    results: PropTypes.object,
    text: PropTypes.string.isRequired
};

export default SidebarControl;
